import React from 'react'
import { Field } from 'redux-form'
import { Checkbox } from 'lp-components'
import AutoRenewalConsentContent from './AutoRenewalConsentContent'

function AutoRenewalConsentField() {
  return (
    <Field
      className="checkbox inline-checkbox"
      component={Checkbox}
      labelComponent={AutoRenewalConsentContent}
      name="autoRenewalConsent"
      required
    />
  )
}

export default AutoRenewalConsentField
